export const NEW_ROLE_FLAG = 'NEW';
export const NO_ROLE_FLAG = 'none';

export const NO_ROLE_OPTION = {
  value: NO_ROLE_FLAG,
  label: 'No role',
  hint: 'No role-based firewall rules',
};

export const NEW_ROLE_OPTION = {
  value: NEW_ROLE_FLAG,
  label: 'Add new role',
  hint: '',
};
